import React from 'react';
import Layout from '../pageComponents/layout/layout';
import GoNationContext from '../context/GoNationContext';
import getPageWrapper from '../helpers/getPageWrapper';
const BasicTemplate = props => {
  var _props$pageContext;
  const {
    type
  } = props === null || props === void 0 ? void 0 : (_props$pageContext = props.pageContext) === null || _props$pageContext === void 0 ? void 0 : _props$pageContext.pageContext;
  const dataEndpoints = props.data.allDataFetchingYaml.edges;
  const {
    gonationID
  } = props.data.businessData;
  return /*#__PURE__*/React.createElement(GoNationContext.Provider, {
    value: {
      businessData: props.data.businessData,
      allPages: props.data.allPageDataYaml,
      pageContext: props.pageContext,
      dataEndpoints
    }
  }, /*#__PURE__*/React.createElement(Layout, {
    data: props
  }, getPageWrapper(type, props, gonationID)));
};
export default BasicTemplate;
const query = "2514142959";